import React from 'react';
import { SectionShell } from './SectionShell';
import { approach } from '../data/caseStudy';
export function Approach() {
  return <SectionShell number="04" title="How I approached it" tone="dark" eyebrow="Four phases, run sequentially but with governance designed in from the second phase onward rather than bolted on at the end." data-id="element-13" data-mp="ubkcv7qeyy72">
      <ol className="border-t border-white/15" data-id="element-14" data-mp="lam8goc2cony">
        {approach.map(phase => <li key={phase.step} className="grid grid-cols-12 gap-10 border-b border-white/15 py-10" data-id="element-15" data-mp="1i0ln90it4jez">
            <p className="col-span-1 font-display text-[44px] font-bold leading-none tracking-tightest text-white/30" data-id="element-16" data-mp="1dz0818isvt1m">
              {phase.step}
            </p>
            <h3 className="col-span-4 font-display text-2xl font-semibold leading-tight tracking-tightest text-white" data-id="element-17" data-mp="142576iz21gk6">
              {phase.title}
            </h3>
            <div className="col-span-7 space-y-5" data-id="element-18" data-mp="3otffeiac6f95">
              <p className="text-[15px] leading-relaxed text-white/75" data-id="element-19" data-mp="3orkx7bqg918r">{phase.body}</p>
              {phase.note ? <p className="border-l-2 border-accent-cyan pl-6 text-[15px] leading-relaxed text-white/75" data-id="element-20" data-mp="2qrzf0uayjohp">
                  {phase.note}
                </p> : null}
            </div>
          </li>)}
      </ol>

      <figure className="mt-16" data-id="element-21" data-mp="2luharh7vxxg1">
        <img src="https://cdn.magicpatterns.com/uploads/mnfbdKBWx6XQJe8ySWbfpg/Group_889.png" alt="Pages from the CreateFuture brand guidelines covering brand story, tone of voice, logotype lockups, typography and the core colour palette" className="w-full border border-white/12 object-cover" data-id="element-22" data-mp="2ltpj2hhesjv1" />
        <figcaption className="mt-5 text-sm text-white/50" data-id="element-23" data-mp="1y3ldw5okoc1x">
          The system itself: colour and type foundations, master templates and annotated governance grounded
          in real pages rather than abstract rules.
        </figcaption>
      </figure>

      <figure className="mt-12" data-id="element-24" data-mp="1t50bq0prfiau">
        <img src="https://cdn.magicpatterns.com/uploads/nGDNzyLMGwAKpzkzHnUdLW/Group_888.png" alt="Campaign and event collateral produced from the new brand system, including social posts and a Tech Leaders Forum event asset" className="w-full border border-white/12 object-cover" data-id="element-25" data-mp="1t8fpn07p6lao" />
        <figcaption className="mt-5 text-sm text-white/50" data-id="element-26" data-mp="vctvvx7u8lz7">
          The hardest part wasn't the launch. It was the day after, making sure the brand could live without constant design team intervention.
We built for that from the start, so campaigns, social assets and internal posts could be created seamlessly with a brand that worked.
        </figcaption>
      </figure>
    </SectionShell>;
}